import React from 'react'

import { ZariContext } from '_zari/context'
import { Alert, Portlet, Button, Row, Col } from '_zari/core'

import * as CuentaContableService from 'services/cuentaContable.service'

import * as Sections from './sections'

const portletBreadcrumbs = [
  { name: 'Estados Financieros' },
  { name: 'Cierre Clase 6-7-9' },
  { name: 'Asignación de Enlances' }
]

const AsignacionEnlacesSection = ({ validarCuentasClase6789ConEnlaceCierre }) => {
  const __zariContext = React.useContext(ZariContext)

  const [mostrarEsquemaEnlaces, setMostrarEsquemaEnlaces] = React.useState(false)

  const [infoCuentaClase59, setInfoCuentaClase59] = React.useState(null)
  const [mensajeAlertaError, setMensajeAlertaError] = React.useState(null)

  React.useEffect(() => {
    __zariContext.loader.open('Obteniendo configuracion de cuenta clase 59.')

    CuentaContableService.obtenerCuentaClase59Ejercicios()
      .then(({ data }) => {
        if (data) {
          setInfoCuentaClase59(data)
        }
      })
      .catch(({ data: { error } }) => {
        setMensajeAlertaError(error)
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Estados Financieros' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          {mensajeAlertaError && (
            <Row>
              <Col md={12}>
                <Alert color='danger'>{mensajeAlertaError}</Alert>
              </Col>
            </Row>
          )}
          {infoCuentaClase59 && (
            <>
              <Row>
                <Col md={6}>
                  <Sections.EnlacesDefectoSection
                    infoCuentaClase59={infoCuentaClase59}
                    validarCuentasClase6789ConEnlaceCierre={validarCuentasClase6789ConEnlaceCierre}
                  />
                </Col>
                <Col md={6}>
                  {!mostrarEsquemaEnlaces && (
                    <Button tiny onClick={() => setMostrarEsquemaEnlaces(true)}>
                      Mostrar esquema
                    </Button>
                  )}
                </Col>
              </Row>
              {mostrarEsquemaEnlaces && <Sections.EsquemaEnlacesSection />}
            </>
          )}
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default React.memo(AsignacionEnlacesSection)
